import { CheckoutState } from '../../checkoutState';
import { ModifierPaymentOptionsCallbackType, StateType } from '../types';

export const reducer = (cbFn: ModifierPaymentOptionsCallbackType, state: StateType): CheckoutState => {
  const payment = cbFn(state?.orderOptions?.payment);

  if (!state) {
    return {} as CheckoutState;
  }
  return {
    ...state,
    orderOptions: {
      ...state.orderOptions,
      payment,
    }
  } as CheckoutState;
};

const paymentOptionsModifier = (cbFn: ModifierPaymentOptionsCallbackType, state: StateType) => reducer(cbFn, state);

export default paymentOptionsModifier;